import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null, 
  loading: false,
};

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setUser(state, action) {
      state.user = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    clearUser(state) {
      state.user = null; 
    },
  },
});

export const { setUser, setLoading, clearUser } = profileSlice.actions;
export default profileSlice.reducer;
